module.exports = __webpack_public_path__ + "static/media/Vu_Minh_Hai.1c0178ce.jpg";